module.exports = __webpack_public_path__ + "static/media/productos_botanas_maiz_chile_limon.c03ae2bb.jpg";